export interface Game {
  id: string;
  title: string;
  sub: string;
  studio: string;
  year: number;
  category: string;
  score: number;
  platform: string;
  tags: string[];
  blurb: string;
  cover: string;
  pros: string[];
  cons: string[];
  isMasterpiece: boolean;
  isBeginner: boolean;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const categories: Category[] = [
  { id: "campus", name: "校园纯爱", icon: "ri-school-line", desc: "青涩与悸动交织的青春物语，适合初次入坑" },
  { id: "fantasy", name: "奇幻冒险", icon: "ri-sparkling-2-line", desc: "异世界与魔法王国的壮阔叙事，世界观宏大" },
  { id: "city", name: "都市职场", icon: "ri-building-2-line", desc: "写实的都市生活与成人关系，代入感强" },
  { id: "thriller", name: "悬疑惊悚", icon: "ri-mist-line", desc: "悬疑烧脑与情感深度并重，剧情党最爱" },
  { id: "harem", name: "后宫多线", icon: "ri-heart-add-line", desc: "多角色可攻略的分支体验，周目耐玩" },
  { id: "healing", name: "治愈日常", icon: "ri-sun-foggy-line", desc: "温柔细腻的日常陪伴，适合放松慢玩" },
  { id: "dark", name: "暗黑题材", icon: "ri-skull-line", desc: "直面欲望与人性的沉重叙事，口碑两极" },
  { id: "world", name: "架空世界观", icon: "ri-earth-line", desc: "自成一派的设定与规则，创新玩法代表" },
];

export const games: Game[] = [
  {
    id: "sakura-convenience",
    title: "樱花便利店物语",
    sub: "Sakura Mart Story",
    studio: "月见草工房",
    year: 2024,
    category: "campus",
    score: 9.1,
    platform: "PC / Switch",
    tags: ["校园", "纯爱", "多结局", "低门槛"],
    blurb: "深夜便利店里的相遇与离别，把普通打工日常写出了让人眼眶发热的温度，是公认的成人游戏入门首选。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20cozy%20night%20convenience%20store%20interior%20with%20warm%20glow%20and%20falling%20cherry%20blossom%20petals%2C%20two%20character%20silhouettes%20by%20the%20counter%2C%20soft%20dreamy%20lighting%2C%20warm%20amber%20and%20rose%20palette%2C%20mature%20romantic%20slice%20of%20life%20mood%2C%20clean%20editorial%20game%20key%20art&width=600&height=800&seq=cover-sakura-001&orientation=portrait",
    pros: ["上手零门槛，无复杂系统", "剧情细腻不注水", "多结局分支有回刷价值"],
    cons: ["演出偏静态", "后期节奏略慢"],
    isMasterpiece: true,
    isBeginner: true,
  },
  {
    id: "echo-of-starsea",
    title: "星海的回响",
    sub: "Echo of the Starsea",
    studio: "青岚社",
    year: 2023,
    category: "fantasy",
    score: 9.4,
    platform: "PC / Console",
    tags: ["奇幻", "史诗", "神作", "长剧本"],
    blurb: "以漂浮群岛为舞台的奇幻长剧，角色塑造与情感爆发力俱佳，是近年成人游戏中最接近「神作」之名的作品。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20fantasy%20visual%20novel%20cover%20art%2C%20a%20lone%20girl%20gazing%20at%20a%20glowing%20ocean%20of%20stars%20above%20floating%20islands%2C%20dramatic%20warm%20gold%20and%20deep%20crimson%20twilight%20sky%2C%20cinematic%20and%20elegant%2C%20mature%20epic%20fantasy%20mood%2C%20refined%20editorial%20key%20art&width=600&height=800&seq=cover-starsea-001&orientation=portrait",
    pros: ["剧本体量扎实", "人物弧光完整", "美术与配乐顶级"],
    cons: ["全通时长偏长", "部分支线略拖"],
    isMasterpiece: true,
    isBeginner: false,
  },
  {
    id: "midnight-office",
    title: "深夜写字楼",
    sub: "The Night Bureau",
    studio: "纸间制作组",
    year: 2024,
    category: "city",
    score: 8.7,
    platform: "PC",
    tags: ["都市", "职场", "成人", "写实"],
    blurb: "把成年人的职场疲惫与欲望摊开来写，台词真实到让人会心一笑，是都市题材里难得的成熟之作。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20dim%20modern%20high%20rise%20office%20at%20night%20with%20city%20lights%20through%20large%20windows%2C%20two%20adult%20figures%20talking%20at%20a%20desk%2C%20moody%20warm%20gold%20and%20deep%20red%20lighting%2C%20sophisticated%20mature%20urban%20mood%2C%20editorial%20key%20art&width=600&height=800&seq=cover-office-001&orientation=portrait",
    pros: ["对白成熟克制", "都市氛围到位", "短而精，一晚上能通"],
    cons: ["分支深度一般"],
    isMasterpiece: false,
    isBeginner: true,
  },
  {
    id: "fog-city-riddle",
    title: "雾都迷局",
    sub: "Fogbound Case Files",
    studio: "黑匣工作室",
    year: 2022,
    category: "thriller",
    score: 9.0,
    platform: "PC",
    tags: ["悬疑", "侦探", "烧脑", "多结局"],
    blurb: "雾气弥漫的城市与环环相扣的谜题，推理体验不输正统侦探游戏，情感线也意外地动人。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20rainy%20noir%20city%20street%20shrouded%20in%20fog%20with%20street%20lamps%20glowing%20warm%20amber%2C%20a%20detective%20figure%20holding%20a%20briefcase%20in%20silhouette%2C%20tense%20mysterious%20mood%2C%20gold%20and%20deep%20crimson%20tones%2C%20editorial%20key%20art&width=600&height=800&seq=cover-fogcity-001&orientation=portrait",
    pros: ["谜题设计环环相扣", "氛围营造一流", "多周目线索完整"],
    cons: ["开篇信息量偏大"],
    isMasterpiece: true,
    isBeginner: false,
  },
  {
    id: "corridor-of-hearts",
    title: "心之回廊",
    sub: "Corridor of Hearts",
    studio: "白鹿工作室",
    year: 2023,
    category: "healing",
    score: 8.9,
    platform: "PC / Mobile",
    tags: ["治愈", "日常", "轻松", "短篇"],
    blurb: "像一杯温热的茶，没有大风大浪，只有细腻的陪伴与温柔的告别，疲惫时点开就会安静下来。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20warm%20sunlit%20reading%20room%20with%20a%20window%20seat%2C%20soft%20morning%20light%20and%20a%20cup%20of%20tea%2C%20gentle%20cozy%20and%20peaceful%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20soothing%20healing%20mood%2C%20clean%20editorial%20key%20art&width=600&height=800&seq=cover-hearts-001&orientation=portrait",
    pros: ["节奏舒缓治愈", "配乐温柔", "单周目体量友好"],
    cons: ["情节冲突较弱"],
    isMasterpiece: false,
    isBeginner: true,
  },
  {
    id: "throne-of-night",
    title: "暗夜王座",
    sub: "Throne of the Night",
    studio: "荆棘之冠",
    year: 2024,
    category: "dark",
    score: 8.5,
    platform: "PC",
    tags: ["暗黑", "人性", "沉重", "口碑两极"],
    blurb: "直面权力与欲望的黑暗寓言，剧情压抑却锋利，喜欢沉重叙事的玩家会爱不释手，反之请谨慎。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20dark%20gothic%20throne%20room%20with%20candlelight%20and%20long%20shadows%2C%20a%20crowned%20figure%20in%20silhouette%20among%20thorns%2C%20heavy%20dramatic%20mood%2C%20deep%20crimson%20and%20gold%20palette%2C%20brooding%20and%20elegant%2C%20editorial%20key%20art&width=600&height=800&seq=cover-throne-001&orientation=portrait",
    pros: ["题材大胆有深度", "演出冲击力强", "音乐极具压迫感"],
    cons: ["剧情致郁", "受众局限"],
    isMasterpiece: false,
    isBeginner: false,
  },
  {
    id: "eden-archipelago",
    title: "伊甸群岛",
    sub: "Eden Archipelago",
    studio: "南屿社",
    year: 2021,
    category: "world",
    score: 9.3,
    platform: "PC / Console",
    tags: ["架空", "创新", "神作", "探索"],
    blurb: "自成一派的岛屿世界观与探索式叙事，把自由度做到了成人游戏的天花板，十年难遇的标杆之作。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20fantasy%20visual%20novel%20cover%20art%2C%20a%20tropical%20floating%20island%20archipelago%20under%20a%20golden%20dusk%20sky%2C%20warm%20coral%20and%20amber%20palette%2C%20explorative%20mysterious%20paradise%20mood%2C%20cinematic%20and%20breathtaking%2C%20refined%20editorial%20key%20art&width=600&height=800&seq=cover-eden-001&orientation=portrait",
    pros: ["自由度极高", "探索奖励充实", "世界观完整自洽"],
    cons: ["需要耐心上手"],
    isMasterpiece: true,
    isBeginner: false,
  },
  {
    id: "summer-fireworks",
    title: "夏日烟火大会",
    sub: "Summer Fireworks",
    studio: "萤火社",
    year: 2023,
    category: "campus",
    score: 8.6,
    platform: "PC / Mobile",
    tags: ["校园", "青春", "夏天", "轻松"],
    blurb: "祭典、浴衣与告白，把少年少女的夏天装进一部作品里，糖分恰到好处，入坑非常友好。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20summer%20festival%20fireworks%20over%20a%20lake%20with%20lanterns%2C%20two%20young%20characters%20in%20yukata%20watching%20the%20sky%2C%20warm%20golden%20and%20coral%20night%20palette%2C%20bright%20youthful%20romantic%20mood%2C%20clean%20editorial%20key%20art&width=600&height=800&seq=cover-fireworks-001&orientation=portrait",
    pros: ["画面明快青春", "糖分适中", "节奏轻快"],
    cons: ["剧情较常规"],
    isMasterpiece: false,
    isBeginner: true,
  },
  {
    id: "entropy-detective",
    title: "逆熵侦探社",
    sub: "Entropy Detective Club",
    studio: "量子狐狸",
    year: 2024,
    category: "thriller",
    score: 8.8,
    platform: "PC",
    tags: ["悬疑", "科幻", "脑洞", "群像"],
    blurb: "当时间可以倒流，谜题便有了新的维度。硬核科幻外壳下藏着一颗温柔的心，烧脑党的年度惊喜。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20sci%20fi%20detective%20office%20with%20floating%20holographic%20screens%20and%20warm%20teal%20and%20gold%20glow%2C%20a%20sleuth%20figure%20in%20silhouette%2C%20clever%20mind%20bending%20mood%2C%20editorial%20key%20art&width=600&height=800&seq=cover-entropy-001&orientation=portrait",
    pros: ["设定脑洞大", "群像塑造出色", "逻辑自洽"],
    cons: ["世界观门槛高"],
    isMasterpiece: false,
    isBeginner: false,
  },
  {
    id: "castle-promise",
    title: "古堡的约定",
    sub: "The Castle Promise",
    studio: "雾鹿社",
    year: 2022,
    category: "fantasy",
    score: 8.4,
    platform: "PC",
    tags: ["奇幻", "言情", "古堡", "浪漫"],
    blurb: "一座被诅咒的古堡与一封迟到十年的信，浪漫悬疑并重，情感浓度高，适合喜欢童话质感的玩家。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20fantasy%20visual%20novel%20cover%20art%2C%20a%20fairytale%20castle%20on%20a%20cliff%20at%20dusk%20with%20warm%20windows%20glowing%20and%20an%20old%20envelope%20in%20the%20foreground%2C%20romantic%20mysterious%20mood%2C%20warm%20gold%20and%20rose%20palette%2C%20editorial%20key%20art&width=600&height=800&seq=cover-castle-001&orientation=portrait",
    pros: ["氛围浪漫", "情感刻画细腻", "配乐出色"],
    cons: ["节奏偏慢"],
    isMasterpiece: false,
    isBeginner: false,
  },
  {
    id: "crimson-spy",
    title: "红唇密探",
    sub: "Crimson Operative",
    studio: "胭脂制作组",
    year: 2023,
    category: "city",
    score: 8.2,
    platform: "PC",
    tags: ["都市", "谍战", "成人", "爽快"],
    blurb: "都市谍战题材的成人恋爱剧，紧张刺激与暧昧并存，短平快节奏适合下班放松。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20glamorous%20noir%20nightclub%20with%20red%20curtains%20and%20golden%20lights%2C%20an%20elegant%20spy%20figure%20in%20silhouette%20with%20a%20fedora%2C%20sleek%20sultry%20mood%2C%20deep%20crimson%20and%20gold%20palette%2C%20editorial%20key%20art&width=600&height=800&seq=cover-spy-001&orientation=portrait",
    pros: ["节奏紧凑", "题材新颖", "演出流畅"],
    cons: ["深度稍欠"],
    isMasterpiece: false,
    isBeginner: false,
  },
  {
    id: "starlight-academy",
    title: "星轨学园",
    sub: "Starlight Academy",
    studio: "天青工房",
    year: 2024,
    category: "harem",
    score: 8.8,
    platform: "PC",
    tags: ["后宫", "多线", "声优豪华", "耐玩"],
    blurb: "多女主可攻略的学院群像，每位角色都有一整条精心打磨的个人线，后宫题材的集大成者。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20visual%20novel%20cover%20art%2C%20a%20starry%20night%20academy%20courtyard%20with%20glowing%20windows%20and%20floating%20constellation%20lights%2C%20several%20character%20silhouettes%20under%20the%20moon%2C%20warm%20gold%20and%20deep%20blue%20night%20palette%2C%20energetic%20multi%20heroine%20mood%2C%20editorial%20key%20art&width=600&height=800&seq=cover-starlight-001&orientation=portrait",
    pros: ["角色线完整", "声优阵容豪华", "周目耐玩度高"],
    cons: ["总时长较长"],
    isMasterpiece: false,
    isBeginner: false,
  },
];